import React from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import consolidatedvieworderStyle from './ConsolidatedOrdersViewOrderPage.module.css'
import BackBar from '../../components/BackBar/BackBar';
import { LuPrinter } from "react-icons/lu";
import { IoShareSocialOutline } from "react-icons/io5";

export default function ConsolidatedOrdersViewOrderPage() {
  return (
    <>
      <AdminHeader />
      <div className={consolidatedvieworderStyle.consolidatedordersvieworderpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={consolidatedvieworderStyle.consolidatedordersvieworderBody}>
                <div className={`${consolidatedvieworderStyle.consolidatedButtons} d-flex flex-wrap align-items-center`}>
                  <button className={`${consolidatedvieworderStyle.consolidatedBackbtn} btn btn-primary me-auto`}>Back</button>
                  <div>
                    <button className={`${consolidatedvieworderStyle.consolidatedSharebtn} btn btn-secondary me-3`}>
                      <IoShareSocialOutline className={`${consolidatedvieworderStyle.consolidatedIcons} me-2`} />Share
                    </button>
                    <button className={`${consolidatedvieworderStyle.consolidatedPrintbtn} btn btn-secondary`}>
                      <LuPrinter className={`${consolidatedvieworderStyle.consolidatedIcons} me-2`} />Print
                    </button>
                  </div>
                </div>
                <div className={`${consolidatedvieworderStyle.consolidatedTitles} d-flex flex-wrap align-items-center`}>
                  <h4 className="me-auto">Event Name: Storytime Spectacular: An Evening….</h4>
                  <h4>Order Number: 000000</h4>
                </div>
                <div className="table-responsive">
                  <table className={`${consolidatedvieworderStyle.consolidatedTables} table table-striped table-bordered`}>
                    <thead>
                      <tr>
                        <th>ISBN</th>
                        <th>Titles</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Line Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0000000000000</td>
                        <td>The Enchanted Forest</td>
                        <td>$00.00</td>
                        <td>1</td>
                        <td>$00.00</td>
                      </tr>
                      <tr>
                        <td>0000000000000</td>
                        <td>Mystic Mountain</td>
                        <td>$00.00</td>
                        <td>1</td>
                        <td>$00.00</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="row">
                  <div className="col-xl-9"> </div>
                  <div className="col-xl-3">
                    <div className={consolidatedvieworderStyle.totalsubtotalBox}>
                      <div className="mb-2 row align-items-center">
                        <label className={`${consolidatedvieworderStyle.consolidatedLabels} col-sm-6 col-form-label text-end`}>Total</label>
                        <div className="col-sm-6 text-end">
                          <span> $00.00 </span>
                        </div>
                      </div>
                      <div className="mb-2 row align-items-center">
                        <label className={`${consolidatedvieworderStyle.consolidatedLabels} ${consolidatedvieworderStyle.colorsconsolidated} col-sm-6 col-form-label text-end`}> Grand Total </label>
                        <div className="col-sm-6 text-end">
                          <span className={consolidatedvieworderStyle.colorsconsolidated}> $00.00 </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
